import { NavLink } from 'react-router';
import { useAuth } from '../providers/auth-provider';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@t90/ui';
import {
  Home,
  Package,
  Users,
  FileText,
  BookOpen,
  Folder,
  ArrowRight,
} from 'lucide-react';

const quickLinks = [
  {
    title: 'Getting Started',
    description: 'New to Turn90? Start here for an overview of our organization.',
    href: '/docs/getting-started',
    icon: Home,
  },
  {
    title: 'Operations Manual',
    description: 'Procedures for daily operations, production, and quality control.',
    href: '/docs/operations',
    icon: Package,
  },
  {
    title: 'Program Guide',
    description: 'Information about our workforce development program.',
    href: '/docs/program',
    icon: Users,
  },
  {
    title: 'SOPs & Procedures',
    description: 'Standard operating procedures for all departments.',
    href: '/docs/procedures',
    icon: FileText,
  },
  {
    title: 'Training Materials',
    description: 'Training guides and educational resources.',
    href: '/docs/training',
    icon: BookOpen,
  },
  {
    title: 'Templates',
    description: 'Document templates and forms.',
    href: '/docs/templates',
    icon: Folder,
  },
];

export function HomePage() {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      {/* Welcome section */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">
          Welcome, {user?.full_name?.split(' ')[0] ?? 'there'}!
        </h1>
        <p className="text-lg text-muted-foreground">
          Access Turn90's documentation, procedures, and training materials.
        </p>
      </div>

      {/* Quick links grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {quickLinks.map((link) => (
          <NavLink key={link.href} to={link.href}>
            <Card className="h-full transition-colors hover:bg-muted/50">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="rounded-md bg-primary/10 p-2">
                    <link.icon className="h-5 w-5 text-primary" />
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground" />
                </div>
                <CardTitle className="text-lg">{link.title}</CardTitle>
                <CardDescription>{link.description}</CardDescription>
              </CardHeader>
            </Card>
          </NavLink>
        ))}
      </div>

      {/* Recent updates section */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Recent Updates</h2>
        <Card>
          <CardHeader>
            <CardDescription>
              Check back soon for recent documentation updates and announcements.
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </div>
  );
}
